module.exports = __webpack_public_path__ + "img/MAX_color.66e7c53.svg";